import { render, staticRenderFns } from "./Usercenter.vue?vue&type=template&id=bcc00a36&scoped=true&"
import script from "./Usercenter.vue?vue&type=script&lang=js&"
export * from "./Usercenter.vue?vue&type=script&lang=js&"
import style0 from "./Usercenter.vue?vue&type=style&index=0&id=bcc00a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc00a36",
  null
  
)

export default component.exports